import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { BannerSlider, type BannerItem } from './BannerSlider';
const bonuses: BannerItem[] = [{
  id: '01',
  label: 'Bonus 01',
  title: 'SESSION BUILDER CARD PACK',
  badge: 'Free Today',
  image: 'https://images.unsplash.com/photo-1517842645767-c639042777db?auto=format&fit=crop&w=1600&q=80',
  description: 'One-page visual reference for each volume. Print it, laminate it, stick it on your wall. Never lose your place mid-class again.'
}, {
  id: '02',
  label: 'Bonus 02',
  title: '300+ VERBAL CUE LIBRARY',
  badge: 'Free Today',
  image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&w=1600&q=80',
  description: "Every cue you'll ever need — anatomical, feel-based, motivational and breath cues — organized by body part and session phase. Sound like a veteran from day one."
}, {
  id: '03',
  label: 'Bonus 03',
  title: 'STUDENT TAKE-HOME SHEETS',
  badge: 'Free Today',
  image: 'https://images.unsplash.com/photo-1554284126-aa88f22d8b74?auto=format&fit=crop&w=1600&q=80',
  description: '6 branded printable handouts — one per volume theme — with homework stretches for your students. Your logo, your name, your professional image.'
}, {
  id: '04',
  label: 'Bonus 04',
  title: '8-WEEK TEACHING ROADMAP',
  badge: 'Free Today',
  image: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?auto=format&fit=crop&w=1600&q=80',
  description: 'Your next two months of classes already planned. A pre-built schedule using all 6 volumes with progression logic, recycling notes and formats for group, private and online delivery.'
}, {
  id: '05',
  label: 'Bonus 05',
  title: 'NEW STUDENT INTAKE PACK',
  badge: 'Free Today',
  image: 'https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?auto=format&fit=crop&w=1600&q=80',
  description: 'A simple mobility assessment form, goal-setting questionnaire and session recommendation guide. Transform a random first class into a professional onboarding experience.'
}];
export function BonusesSection() {
  return <section className="py-12 sm:py-24 bg-slate-900 text-white relative overflow-hidden" data-id="element-35">
      <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/4dgsTa4MyNzpLdaXEDcrK2/Gemini_Generated_Image_8lvaxp8lvaxp8lva-Photoroom.png')] bg-cover bg-center opacity-5 mix-blend-overlay" data-id="element-36" />
      <div className="absolute -bottom-1/4 right-1/2 translate-x-1/2 h-[36rem] w-[36rem] rounded-full bg-amber-500/10 blur-[120px]" data-id="element-37" />

      <div className="relative mx-auto max-w-5xl px-4 sm:px-6 lg:px-8" data-id="element-38">
        <div className="mx-auto max-w-3xl text-center mb-10 sm:mb-16" data-id="element-39">
          <div className="inline-flex items-center justify-center rounded-full bg-amber-400/10 px-3 sm:px-4 py-1 sm:py-1.5 mb-4 sm:mb-6" data-id="element-40">
            <Gift className="mr-1.5 sm:mr-2 h-4 w-4 sm:h-5 sm:w-5 text-amber-400" data-id="element-41" />
            <span className="text-xs sm:text-sm font-semibold text-amber-400 uppercase tracking-[0.2em]" data-id="element-42">
              Plus 5 Free Bonuses Today
            </span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-white text-balance" data-id="element-43">
            We've packed an additional{' '}
            <span className="text-amber-400" data-id="element-44">400+ pages</span> of high-value
            resources
          </h2>
          <p className="mt-4 sm:mt-6 text-base sm:text-lg leading-7 sm:leading-8 text-slate-400" data-id="element-45">
            To make sure you have absolutely everything you need to succeed.
          </p>
        </div>

        <BannerSlider items={bonuses} accent="bonus" data-id="element-46" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-8 sm:mt-12 rounded-xl sm:rounded-2xl bg-gradient-to-r from-brand-600 to-brand-500 p-6 sm:p-8 text-center shadow-xl hover:shadow-2xl transition-shadow" data-id="element-47">
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-1 sm:mb-2" data-id="element-48">
            Total Bonus Value: $182 — TODAY FREE
          </h3>
          <p className="text-sm sm:text-base text-brand-50" data-id="element-49">
            Included in your complete system at no extra cost.
          </p>
        </motion.div>
      </div>
    </section>;
}